import { AnswersState, CreateAnswerDTO, FeedbackQuestion, QuestionType } from '../../../../types';

export function formatAnswers(
  answers: AnswersState,
  questions: FeedbackQuestion[]
): CreateAnswerDTO[] {
  return Object.entries(answers)
    .map(([questionId, value]) => {
      const question = questions.find((q) => q.id === Number(questionId)) as FeedbackQuestion;
      const answerDTO: CreateAnswerDTO = {
        questionId: Number(questionId),
      };

      if (question?.questionType === QuestionType.TEXT) {
        // Only set textValue if it's not empty
        if (value && typeof value === 'string' && value.trim() !== '') {
          answerDTO.textValue = value as string;
        } else {
          // Return null for empty text values, these will be filtered out
          return null;
        }
      } else if ([QuestionType.RATING, QuestionType.NPS].includes(question?.questionType)) {
        answerDTO.numericValue = value as number;
      }

      return answerDTO;
    })
    .filter((answer) => answer !== null);
}
